/* global process */

import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'

export const CHALLENGES_RESULTS_REQUEST = 'challenges_results/REQUEST'
export const CHALLENGES_RESULTS_SUCCESS = 'challenges_results/SUCCESS'
export const CHALLENGES_RESULTS_ERROR = 'challenges_results/ERROR'

export function startRequest() {
    return {
        type: CHALLENGES_RESULTS_REQUEST,
        payload: {},
    }
}

export function requestSuccess(data) {
    const {
        account_rewards: accountRewards,
        clan_rewards: clanRewards,
    } = data
    const results = { accountRewards, clanRewards }
    return {
        type: CHALLENGES_RESULTS_SUCCESS,
        payload: { results },
    }
}

export function requestError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: CHALLENGES_RESULTS_ERROR,
        payload: errorData,
    }
}

export default function requestChallengesResults(challengeId) {
    return async (dispatch, getState) => {
        if (getState().challengesResults.loading) {
            return
        }
        dispatch(startRequest())

        // Mock of Challenges results request for development issues
        if (process.env.API_ENV === 'mock') {
            const CHALLENGES_RESULTS_MOCK = require('containers/ChallengesResults/mock').default
            if (challengeId === 'dev') {
                const results = CHALLENGES_RESULTS_MOCK
                return dispatch(requestSuccess(results))
            }
        }

        const url = `/game_api/challenges/${challengeId}/reward`
        httpRequest(url)
            .then(
                data => dispatch(requestSuccess(data)),
                errorData => dispatch(requestError(errorData))
            )
    }
}



// WEBPACK FOOTER //
// ./state/actions/challenges_results.js